import React, { useState, useEffect, useRef } from "react";

const LazyVideo = (props: any) => {
    const { src, poster, className, style, ...rest } = props;
    const [shouldLoad, setShouldLoad] = useState(false);
    const videoRef = useRef<HTMLVideoElement>(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting) {
                    setShouldLoad(true);
                    observer.disconnect();
                }
            },
            { threshold: 0.1 }
        );

        if (videoRef.current) {
            observer.observe(videoRef.current);
        }

        return () => {
            if (observer) observer.disconnect();
        };
    }, []);

    return (
        <video
            ref={videoRef}
            className={`lazy-video ${className || ""}`}
            style={style}
            poster={poster}
            {...rest}
        >
            {shouldLoad && <source src={src} type="video/mp4" />}
            Your browser does not support the video tag.
        </video>
    );
};

export default LazyVideo;
